import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from 'react-redux';
import { Registerer, UserAgent } from "sip.js";
import { getConnInfo, setConnInfo } from '../utils/sessionstorage.js';

const PreLoginPage = ({ phone, dispatch }) => {
  const { search } = useLocation();
  const [statusText, setStatusText] = useState('Connecting to Phone System...');
  const navigate = useNavigate();

  const initConn = async () => {
    const urlSearch = new URLSearchParams(search);
    const sipDomain = urlSearch.get('sipDomain');
    const username = urlSearch.get('username');
    const password = urlSearch.get('password');
    const task = urlSearch.get('task');
    const taskDestination = urlSearch.get('taskDestination');
    const reportUrl = urlSearch.get('reportUrl');
    const reportNonce = urlSearch.get('reportNonce');
    let connInfo = {
      sipDomain, username, password, task, taskDestination, reportUrl, reportNonce
    };

    const savedInfo = getConnInfo();
    if (savedInfo && !reportUrl) {
      connInfo = savedInfo;
    } else {
      if (!sipDomain || !username || !password || !task) {
        setStatusText('Missing information. Please check your URL.');
        return;
      }
    }

    await dispatch({
      type: 'phone/setFields',
      payload: {
        connInfo,
      },
    });

    setConnInfo(connInfo);

    // Handle Sip Sign On
    const userAgent = new UserAgent({
      uri: UserAgent.makeURI(`sip:${connInfo.username}@${connInfo.sipDomain}`),
      authorizationPassword: connInfo.password,
      authorizationUsername: connInfo.username,
      registerExpires: 30,
      transportOptions: {
        server: `wss://${connInfo.sipDomain}`,
      },
      // delegate: {
      //   onInvite: payload.onInvite,
      // },
    });
    const registerer = new Registerer(userAgent, {
      expires: 45,
    });
    await userAgent.start();
    await registerer.register();
    await new Promise((res) => setTimeout(res, 1500));
    await dispatch({
      type: 'phone/setFields',
      payload: {
        userAgent,
        registerer,
      },
    });
    await new Promise((res) => setTimeout(res, 1500));
    navigate('/waiting', { replace: true });
  };
  useEffect(() => {
    initConn();
  }, []);

  return (
    <div className="flex flex-col justify-start items-stretch">
      <div className="p-3 text-center font-xs">{statusText}</div>
    </div>
  );
};

export default connect(({
  phone
}) => ({
  phone
}))(PreLoginPage);
